/**
 * useGuideCatalog (web) — thin wrapper over the shared @wg/hooks
 * implementation, injecting this app's configured axios client. Logic lives in
 * @wg/hooks/guides so web and RN stay in lockstep.
 */
import { useGuideCatalog as useSharedGuideCatalog } from '@wg/hooks/guides';

import httpClient from '../http';

export type { Guide } from '@wg/hooks/guides';

export function useGuideCatalog(enabled = true) {
  return useSharedGuideCatalog(httpClient, enabled);
}

export default useGuideCatalog;
